import { FC } from 'react'

import {
  Text,
  GreyGrey60,
  Primary13Regular,
  Center
} from '@sequencehq/core-components'

import { useAutomationId } from 'Automations/automationEditor/hooks'
import { SidebarTemplate } from '../../components'
import { CurrentVersion } from './CurrentVersion'
import { PastVersions } from './PastVersions'

export const VersionHistory: FC = () => {
  const { isNewAutomation } = useAutomationId()

  return (
    <SidebarTemplate data-testid="automations.editor.versionHistory">
      <SidebarTemplate.Header
        title="Version history"
        data-testid="automations.editor.versionHistory.header"
      />

      {isNewAutomation ? (
        <Center
          data-testid="automations.editor.versionHistory.emptyState"
          width="100%"
          height="100%"
        >
          <Text {...Primary13Regular} color={GreyGrey60}>
            No saved versions
          </Text>
        </Center>
      ) : (
        <SidebarTemplate.Content gap="16px">
          <>
            <CurrentVersion />
            <PastVersions />
          </>
        </SidebarTemplate.Content>
      )}
    </SidebarTemplate>
  )
}
